import { Component, Input } from '@angular/core';
import { IntegrationsDetails } from '@integrations';

@Component({
  selector: 'app-account-integrations',
  templateUrl: './account-integrations.component.html',
  styleUrls: ['./account-integrations.component.scss'],
})
export class AccountIntegrationsComponent {
  @Input() accountId: string;
  @Input() integrationsLoading = false;
  @Input() integrations: IntegrationsDetails[] = [];
}
